export enum CustomElevationType {
  ELEVATION_PROVIDER_TYPE_ARC_GIS = 'ArcGIS',
}
